import { createCategoriesService } from "./factory";

const categoriesService = createCategoriesService();

export default categoriesService;
